module.exports = __webpack_public_path__ + "static/media/home_view_event_bg.a78f8f15.jpg";